const ProductEnum = {
  FACTORING: 'factoring',
  ORDERING: 'ordering',
  CONFIRMING: 'confirming',
  PRONTO_PAGO: 'pronto pago',
  KOBROS: 'kobros',
};

const smallImageProducts = [ProductEnum.KOBROS, ProductEnum.CONFIRMING];
const productsNotAvailableInMexico = [ProductEnum.ORDERING, ProductEnum.KOBROS];

export { ProductEnum, smallImageProducts, productsNotAvailableInMexico };
